import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { memo } from 'react';

export const PageIndicators = memo(
  ({ totalPages, currentPage, onPageChange, background, gray, handlePrevPage, handleNextPage }) => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        gap: 1,
        mt: 2,
        alignItems: 'center',
      }}
    >
      <IconButton
        disabled={!currentPage}
        onClick={handlePrevPage}
        sx={{
          display: { xs: 'flex', sm: 'none' },
          marginRight: '1rem',
        }}
      >
        <ChevronLeft />
      </IconButton>
      {Array.from({ length: totalPages }).map((_, idx) => (
        <Box
          key={`page-indicator-${idx}`}
          onClick={() => onPageChange(idx)}
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: currentPage === idx ? background : gray,
            cursor: 'pointer',
          }}
        />
      ))}
      <IconButton
        disabled={currentPage === totalPages - 1}
        onClick={handleNextPage}
        sx={{
          display: { xs: 'flex', sm: 'none' },
          marginLeft: '1rem',
        }}
      >
        <ChevronRight />
      </IconButton>
    </Box>
  )
);
